export enum AuthErrorType {
  PHONE_NUMBER_IN_USE = 'PHONE_NUMBER_IN_USE',
  EMAIL_IN_USE = 'EMAIL_IN_USE',
  MFA_NOT_READY = 'MFA_NOT_READY',
  UNKNOWN = 'UNKNOWN',
}

export class AuthError extends Error {
  constructor(
    public readonly type: AuthErrorType,
    public override readonly message: string,
    public readonly language?: string,
  ) {
    super(message);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  toJSON(): any {
    return {
      name: AuthError.name,
      message: this.message,
      type: this.type,
      language: this.language || 'en',
      statusCode: 401,
    };
  }
}
